import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/api/api.service';

@Injectable({ providedIn: 'root' })
export class InformesRxService {

  private readonly base = '/transactions/rx-reports';

  constructor(private api: ApiService) {}

  // `token` es legacy y se ignora (el token va en el header Bearer).

  listarPendientes(_token?: string): Observable<{ rows: any[] }> {
    return this.api.post(`${this.base}/pending/list`, {});
  }

  obtenerInforme(id: number | string, _token?: string): Observable<{ rows: any[] }> {
    return this.api.post(`${this.base}/find`, { id });
  }

  guardarInforme(id: number | string, report: string, _token?: string): Observable<{ id: number | string }> {
    return this.api.post(`${this.base}/save`, { id, report });
  }

  listarServiciosInforme(_token?: string): Observable<{ rows: any[] }> {
    return this.api.post(`${this.base}/report-services/list`, {});
  }

  listarInformesPorOrden(codOrden: number | string, _token?: string): Observable<{ rows: any[] }> {
    return this.api.post(`${this.base}/order/list`, { ordenId: codOrden });
  }

  generarInformeServicio(
    orderId: number | string,
    serviceId: number | string
  ): Observable<Blob> {
    return this.api.postBlob(`${this.base}/service/pdf`, {
      orderId,
      serviceId
    });
  }

  generarInformeCorporal(orderId: number | string): Observable<Blob> {
    return this.api.postBlob(`${this.base}/body/pdf`, { orderId });
  }

  obtenerServiciosUsuario(usuarioId: number, _token?: string): Observable<{ codPros: number[] }> {
    return this.api.post(`${this.base}/user-services/find`, { usuarioId });
  }

  actualizarServiciosUsuario(usuarioId: number, codPros: number[], _token?: string): Observable<{ usuarioId: number }> {
    return this.api.post(`${this.base}/user-services/update`, { usuarioId, codPros });
  }
}
